module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface#toc_marker-3"
    }
  }, [_c('i', [_vm._v("Preface to the Third Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments#toc_marker-4"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction#toc_marker-5"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part1#toc_marker-6"
    }
  }, [_vm._v("Part One: Laying the Foundation")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-7"
    }
  }, [_vm._v("1 Grid Work: A Theological and Ethical Framework")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part2#toc_marker-8"
    }
  }, [_vm._v("Part Two: Reflections on the Basic Assumptions of Economics")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-9"
    }
  }, [_vm._v("2 Me, Myself and Why: Pursuit of Self-Interest Promotes . . . What Exactly?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Waste Not? Reappraising the Goal of Economic Efficiency")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 It’s Mine! Private Property Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 But I’m Positive! Economics as a Science")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part3#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Macroeconomic Issues")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 How Does Your Garden Grow? The Possibilities and Perils of Economic Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Render unto Caesar: The Role of Government in the Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#toc_marker-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Overemployment: The Growth of Work and the Loss of Leisure")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Catching Your Interest: Lending and Borrowing in Scripture and History")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#toc_marker-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Gross Compensation: Executives Rolling in Dough")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part4#toc_marker-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Microeconomic Issues")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 A Clarion Call: Poverty and Distributive Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#toc_marker-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Tending the Garden: Environmental Stewardship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#toc_marker-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Who’s Responsible? Business and Social Responsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#toc_marker-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 False Hope: The Boom in Legalized Gambling")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#toc_marker-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Naked Gorilla: The Ethical and Economic Challenge of the Pornography Industry")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part5#toc_marker-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: International Issues")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#toc_marker-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 A Matter of Life and Debt: Debt Relief for Less-Developed Countries")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#toc_marker-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Give Me Your Tired, Your Poor: The Economics of Immigration")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch18#toc_marker-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 The Malthusian Blues: The Ethics and Economics of Population Control")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch19#toc_marker-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Sand in the Gears: The Corrosive Effect of Corruption")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch20#toc_marker-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Why Waste Resources? Do Rural Development by the Boo")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch21#toc_marker-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Global Poverty: Top Down or Bottom Up?")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#toc_marker-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#toc_marker-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#toc_marker-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("More Titles from InterVarsity Press")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "toc_marker-2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0